module.exports = __webpack_public_path__ + "img/el2.b6599c3e.gif";